import styled from '@emotion/styled';
import { pxToRem } from '../../../../styles/utils';
import { mediaQueries } from '../../../../styles/media-queries';

export const HeaderText = styled('h2')`
  font-size: ${pxToRem(28)};
  line-height: ${pxToRem(32)};
  font-weight: 500;

  ${mediaQueries.tablet} {
    font-size: ${pxToRem(42)};
    line-height: ${pxToRem(48)};
  }
`;
